import { TreeMapNodeState } from '@graftcode/design-system'

import { GATEWAY_STATUS } from '@common/core/components/Layout/const/gateway-status.const'

export const mapGatewayStatusToTreeMapNodeState = (status?: string) => {
  switch (status) {
    case GATEWAY_STATUS.ONLINE:
      return TreeMapNodeState.Active
    case GATEWAY_STATUS.WARNING:
      return TreeMapNodeState.Warning
    case GATEWAY_STATUS.ERROR:
      return TreeMapNodeState.Error
    case GATEWAY_STATUS.OFFLINE:
      return TreeMapNodeState.Inactive
    default:
      return TreeMapNodeState.Inactive
  }
}
